module.exports = __webpack_public_path__ + "img/update.06b591c6.png";